module.exports = __webpack_public_path__ + "static/media/KANTAN_Kanji_LOGO.342334e9.png";